(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-tabs"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('.promo-tabs').forEach(function (root) {

    const tabs   = root.querySelectorAll('.promo-tabs__tab');
    const panels = root.querySelectorAll('.promo-tabs__panel');

    // ── Tab 切换 ──────────────────────────────────────────
    function switchTab(tabSlug) {
      tabs.forEach(t => t.classList.toggle('is-active', t.dataset.tab === tabSlug));
      panels.forEach(p => {
        const isActive = p.dataset.panel === tabSlug;
        p.classList.toggle('is-active', isActive);

        if (!isActive) {
          if (p._anchorObserver) {
            p._anchorObserver.disconnect();
            p._anchorObserver = null;
          }
          if (p._scrollHandler) {
            window.removeEventListener('scroll', p._scrollHandler);
            p._scrollHandler = null;
          }
          if (p._resizeHandler) {
            window.removeEventListener('resize', p._resizeHandler);
            p._resizeHandler = null;
          }
          if (typeof p._clearFixedAnchorNav === 'function') {
            p._clearFixedAnchorNav();
            p._clearFixedAnchorNav = null;
          }
          if (p._anchorClickHandlers) {
            p._anchorClickHandlers.forEach(function (entry) {
              entry.link.removeEventListener('click', entry.handler);
            });
            p._anchorClickHandlers = null;
          }
        }

        if (isActive) observeAnchors(p);
      });
    }

    tabs.forEach(function (tab) {
  tab.addEventListener('click', function () {
    // 关闭 mega menu
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.style.display = 'none';
    });
    switchTab(this.dataset.tab);
  });
});

    // ── Anchor nav: click + scroll (nav order via data-anchor-target) ──
    function observeAnchors(panel) {
      if (panel._anchorObserver) {
        panel._anchorObserver.disconnect();
        panel._anchorObserver = null;
      }
      if (panel._scrollHandler) {
        window.removeEventListener('scroll', panel._scrollHandler);
        panel._scrollHandler = null;
      }
      if (panel._resizeHandler) {
        window.removeEventListener('resize', panel._resizeHandler);
        panel._resizeHandler = null;
      }
      if (typeof panel._clearFixedAnchorNav === 'function') {
        panel._clearFixedAnchorNav();
        panel._clearFixedAnchorNav = null;
      }
      if (panel._anchorClickHandlers) {
        panel._anchorClickHandlers.forEach(function (entry) {
          entry.link.removeEventListener('click', entry.handler);
        });
        panel._anchorClickHandlers = null;
      }

      const anchorLinks = Array.from(panel.querySelectorAll('.promo-tabs__anchor-link'));
      if (!anchorLinks.length) return;

      const promoRoot = panel.closest('.promo-tabs');
      let clickLockUntil = 0;
      let anchorStartY = null;

      function getTargetId(link) {
        return link.dataset.anchorTarget || (link.getAttribute('href') || '').slice(1);
      }

      function clearFixedAnchorNav() {
        const nav = panel.querySelector('.promo-tabs__anchornav');
        if (!nav) return;

        nav.classList.remove('is-fixed');
        panel.classList.remove('has-fixed-anchornav');
        panel.style.removeProperty('--promo-anchor-fixed-offset');
        nav.style.removeProperty('--promo-anchor-fixed-top');
        nav.style.removeProperty('--promo-anchor-fixed-left');
        nav.style.removeProperty('--promo-anchor-fixed-width');
        anchorStartY = null;
      }

      panel._clearFixedAnchorNav = clearFixedAnchorNav;

      function getStickyHeight() {
        const tabbar    = promoRoot ? promoRoot.querySelector('.promo-tabs__tabbar') : null;
        const anchornav = panel.querySelector('.promo-tabs__anchornav');
        let height      = 0;

        if (tabbar && tabbar.getBoundingClientRect().height > 0) {
          height += tabbar.getBoundingClientRect().height;
        }
        if (anchornav) {
          height += anchornav.getBoundingClientRect().height;
        }

        return height;
      }

      function getScrollMargin() {
        const sample = panel.querySelector('.promo-tabs__section');
        if (!sample) return 100;

        const value = parseFloat(getComputedStyle(sample).scrollMarginTop);
        return Number.isFinite(value) ? value : 100;
      }

      function getActivationLine() {
        return Math.max(getStickyHeight() + 8, getScrollMargin());
      }

      function getFixedTop(nav) {
        const value = parseFloat(getComputedStyle(nav).top);
        return Number.isFinite(value) ? value : 0;
      }

      function syncFixedAnchorNav() {
        const nav = panel.querySelector('.promo-tabs__anchornav');
        if (!nav || !promoRoot || !panel.classList.contains('is-active')) {
          clearFixedAnchorNav();
          return;
        }

        const wasFixed = nav.classList.contains('is-fixed');
        if (wasFixed) {
          nav.classList.remove('is-fixed');
          panel.classList.remove('has-fixed-anchornav');
        }

        const navRect = nav.getBoundingClientRect();
        const rootRect = promoRoot.getBoundingClientRect();
        const fixedTop = getFixedTop(nav);
        const navHeight = Math.round(navRect.height);
        const navWidth = Math.round(navRect.width);
        const navLeft = Math.round(navRect.left);

        if (anchorStartY === null || !wasFixed) {
          anchorStartY = window.scrollY + navRect.top;
        }

        const shouldFix = window.scrollY + fixedTop >= anchorStartY &&
          rootRect.bottom > fixedTop + navHeight;

        if (!shouldFix) {
          clearFixedAnchorNav();
          return;
        }

        nav.style.setProperty('--promo-anchor-fixed-top', fixedTop + 'px');
        nav.style.setProperty('--promo-anchor-fixed-left', navLeft + 'px');
        nav.style.setProperty('--promo-anchor-fixed-width', navWidth + 'px');
        panel.style.setProperty('--promo-anchor-fixed-offset', navHeight + 'px');
        panel.classList.add('has-fixed-anchornav');
        nav.classList.add('is-fixed');
      }

      const sections = anchorLinks.map(function (link) {
        const targetId = getTargetId(link);
        return targetId ? document.getElementById(targetId) : null;
      }).filter(Boolean);

      if (!sections.length) return;

      function setActiveLink(targetId) {
        if (!targetId) return;

        anchorLinks.forEach(function (link) {
          const isMatch = getTargetId(link) === targetId;
          link.classList.toggle('is-active', isMatch);

          if (isMatch) {
            const nav = panel.querySelector('.promo-tabs__anchornav');
            if (nav) {
              nav.scrollLeft = link.offsetLeft - (nav.offsetWidth / 2) + (link.offsetWidth / 2);
            }
          }
        });
      }

      function updateActiveFromScroll() {
        syncFixedAnchorNav();

        if (Date.now() < clickLockUntil) return;

        const line       = getActivationLine();
        let currentId    = sections[0].id;
        let containingId = null;

        sections.forEach(function (section) {
          const rect = section.getBoundingClientRect();

          if (rect.top <= line && rect.bottom > line) {
            containingId = section.id;
          }

          if (rect.top <= line) {
            currentId = section.id;
          }
        });

        if (containingId) {
          currentId = containingId;
        }

        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
          currentId = sections[sections.length - 1].id;
        }

        setActiveLink(currentId);
      }

      panel._anchorClickHandlers = [];
      anchorLinks.forEach(function (link) {
        const handler = function () {
          const targetId = getTargetId(link);
          if (!targetId) return;

          setActiveLink(targetId);
          clickLockUntil = Date.now() + 800;
          window.requestAnimationFrame(updateActiveFromScroll);
        };

        link.addEventListener('click', handler);
        panel._anchorClickHandlers.push({ link: link, handler: handler });
      });

      if ('IntersectionObserver' in window) {
        const topInset = Math.round(getActivationLine());

        panel._anchorObserver = new IntersectionObserver(function () {
          updateActiveFromScroll();
        }, {
          root: null,
          rootMargin: '-' + topInset + 'px 0px -55% 0px',
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        });

        sections.forEach(function (section) {
          panel._anchorObserver.observe(section);
        });
      }

      panel._scrollHandler = updateActiveFromScroll;
      panel._resizeHandler = updateActiveFromScroll;

      window.addEventListener('scroll', updateActiveFromScroll, { passive: true });
      window.addEventListener('resize', updateActiveFromScroll, { passive: true });

      updateActiveFromScroll();
    }

    // ── 初始化第一个 panel ────────────────────────────────
    const firstPanel = root.querySelector('.promo-tabs__panel.is-active');
    if (firstPanel) observeAnchors(firstPanel);

  });

  document.querySelectorAll('[data-countdown-end]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-countdown-end'));
    if (!end || isNaN(end)) return;

    var pieces = {
      d: el.querySelector('[data-cd-piece="d"]'),
      h: el.querySelector('[data-cd-piece="h"]'),
      m: el.querySelector('[data-cd-piece="m"]'),
      s: el.querySelector('[data-cd-piece="s"]')
    };

    function pad(n) {
      return ('0' + n).slice(-2);
    }

    function updatePiece(piece, value) {
      if (!piece) return;
      var val = pad(value);
      if (val === piece.dataset.currentValue) return;

      var top = piece.querySelector('.card__top');
      var bottom = piece.querySelector('.card__bottom');
      var back = piece.querySelector('.card__back');
      var backBottom = piece.querySelector('.card__back .card__bottom');
      if (!top || !bottom || !back || !backBottom) return;

      if (piece.dataset.currentValue != null) {
        back.setAttribute('data-value', piece.dataset.currentValue);
        bottom.setAttribute('data-value', piece.dataset.currentValue);
      }

      piece.dataset.currentValue = val;
      top.textContent = val;
      backBottom.setAttribute('data-value', val);

      piece.classList.remove('is-flip');
      void piece.offsetWidth;
      piece.classList.add('is-flip');
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        updatePiece(pieces.d, 0);
        updatePiece(pieces.h, 0);
        updatePiece(pieces.m, 0);
        updatePiece(pieces.s, 0);
        el.hidden = true;
        return;
      }

      updatePiece(pieces.d, Math.floor(diff / 86400000));
      updatePiece(pieces.h, Math.floor((diff % 86400000) / 3600000));
      updatePiece(pieces.m, Math.floor((diff % 3600000) / 60000));
      updatePiece(pieces.s, Math.floor((diff % 60000) / 1000));
    }

    tick();
    setInterval(tick, 1000);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bottom-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-bottom-promo')) {
    class StickyBottomPromo extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.sectionId) return;

        this.sectionId = this.dataset.sectionId;
        this.surface = this.querySelector('[class*="__surface"]');
        this.closeBtn = this.querySelector('[data-close]');
        this.shopLink = this.querySelector('[data-shop-link]');
        this.storageKey = `sticky-bottom-promo-${this.sectionId}`;

        this.dismissed = sessionStorage.getItem(this.storageKey) === '1';
        this.footerVisible = false;
        this.scrolledEnough = false;
        this.bgLoaded = false;
        this.designMode = window.Shopify && Shopify.designMode;
        this.SCROLL_THRESHOLD = 120;

        this.onScroll = this.throttle(this.handleScroll.bind(this), 80);
        this.onResize = this.throttle(() => {
          this.checkFooterVisible();
          this.maybeLoadBackground();
          this.updateVisibility();
        }, 200);

        this.closeBtn?.addEventListener('click', this.handleClose.bind(this));
        this.shopLink?.addEventListener('click', this.handleShopClick.bind(this));

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });

        this.observeFooter();
        this.bindAnchorLink();
        this.handleScroll();

        if (this.designMode) {
          this.classList.add('is-visible');
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.footerObserver?.disconnect();
      }

      getFooterElement() {
        if (this.footerEl?.isConnected) return this.footerEl;

        this.footerEl =
          document.querySelector('.shopify-section--footer') ||
          document.querySelector('footer.footer')?.closest('.shopify-section') ||
          document.getElementById('shopify-section-footer');

        return this.footerEl;
      }

      observeFooter() {
        const footer = this.getFooterElement();
        if (!footer) return;

        this.footerObserver = new IntersectionObserver(
          () => this.checkFooterVisible(),
          { threshold: [0, 0.01, 0.1] }
        );

        this.footerObserver.observe(footer);
      }

      checkFooterVisible() {
        const footer = this.getFooterElement();
        if (!footer) {
          this.footerVisible = false;
          return;
        }

        const rect = footer.getBoundingClientRect();
        this.footerVisible = rect.top <= window.innerHeight;
      }

      bindAnchorLink() {
        if (!this.shopLink) return;
        const firstAnchor = document.querySelector('.promo-tabs__anchor-link');
        if (firstAnchor?.href) {
          this.shopLink.href = firstAnchor.getAttribute('href');
        }
      }

      handleShopClick(event) {
        const href = this.shopLink?.getAttribute('href');
        if (!href || href === '#') return;

        event.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        window.location.href = href;
      }

      handleClose() {
        this.dismissed = true;
        sessionStorage.setItem(this.storageKey, '1');
        this.updateVisibility();
      }

      handleScroll() {
        this.scrolledEnough = window.scrollY > this.SCROLL_THRESHOLD;
        this.checkFooterVisible();
        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow =
          this.designMode ||
          (!this.dismissed && this.scrolledEnough && !this.footerVisible);

        this.classList.toggle('is-visible', shouldShow);

        if (shouldShow) {
          this.maybeLoadBackground();
        }
      }

      maybeLoadBackground() {
        if (this.bgLoaded || !this.surface || !this.dataset.bg) return;
        if (!window.matchMedia('(min-width: 750px)').matches) return;

        this.surface.style.backgroundImage = `url("${this.dataset.bg}")`;
        this.bgLoaded = true;
      }

      throttle(fn, wait) {
        let timeout = null;
        let last = 0;
        return (...args) => {
          const now = Date.now();
          const remaining = wait - (now - last);
          if (remaining <= 0) {
            last = now;
            fn(...args);
          } else {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              last = now;
              fn(...args);
            }, remaining);
          }
        };
      }
    }

    customElements.define('sticky-bottom-promo', StickyBottomPromo);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const promo = document.querySelector(
      `sticky-bottom-promo[data-section-id="${event.detail.sectionId}"]`
    );
    if (!promo) return;

    sessionStorage.removeItem(`sticky-bottom-promo-${event.detail.sectionId}`);
  });

  } catch(e) { console.error(e); }
})();
})();
